import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import LiveShowItem from "../liveshows/liveshowItem";
import { getEventShows} from "./myService";
import {getChannelsFromGenre} from "../header/genreChannel";
import SimpleBackdrop from "../liveshows/background";
import {useMediaQuery, useTheme} from "@mui/material";

const  LiveGenreShowItems = () =>{
    const [channels, setChannels] = useState([])
    const params = useParams()
    const channelGenreId = params.id
    const [isLoading, setLoading] = useState(false)
    const [showEvents, setShowEvents] = useState([])
    const [liveToken, setLiveToken] = useState("")
    const theme = useTheme();
    // Check if the screen is wider than the 'md' breakpoint (Desktop/Large Tablet)
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
       const getChannelsOption = () => {
           getEventShows().then( async (events) => {
               const tokenLive = window.localStorage.getItem("LiveToken")
               const genreChannels = await getChannelsFromGenre(channelGenreId)
               setChannels(genreChannels)
               setShowEvents(events)
               setLiveToken(tokenLive)
               setLoading(true)
           })
       }

       getChannelsOption()

    }, [channels.length, liveToken, channelGenreId]);

    return <>
        {
            !isLoading ? <SimpleBackdrop open={true}></SimpleBackdrop>
                : <div style={{backgroundColor: "black", minHeight:"100vh", height: "100%"}}>

                    <div style={{
                        flexDirection: "row",
                        marginRight: isDesktop? 20 : 10,
                        marginLeft :isDesktop? 50: 10,
                        marginTop: -30,
                        color: "white",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent:"space-between"
                    }}>

                        {channels.map((channel) => {
                            const showsFoundEvent = showEvents.filter((showEvent) => showEvent.id === parseInt(channel?.EpgId))
                            let showsEvent
                            if (showsFoundEvent.length === 1) {
                                showsEvent = showsFoundEvent[0]?.events
                            }
                            return <LiveShowItem key={channel?.id} showEvents={showsEvent} channel={channel}
                                                     liveToken={liveToken}></LiveShowItem>
                        })}
                    </div>
                </div>
        }
    </>

}

export default  LiveGenreShowItems